import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 2,
  class: "container-fluid"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col-lg-10 offset-lg-1",
  style: {"padding-top":"130px"}
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_9 = { class: "lead" }
const _hoisted_10 = { style: {"font-size":"2em","font-weight":"300","color":"#33475b","margin":"0"} }
const _hoisted_11 = { class: "editable editable-success" }
const _hoisted_12 = { class: "lead" }
const _hoisted_13 = {
  key: 0,
  class: "col-lg-6 text-right align-self-end"
}
const _hoisted_14 = { class: "btn-group mr-1" }
const _hoisted_15 = { class: "dropdown-menu dropdown-menu-right" }
const _hoisted_16 = { class: "btn btn-outline-secondary mr-1" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-lg-10 offset-lg-1" }
const _hoisted_19 = {
  key: 0,
  class: "card bg-light"
}
const _hoisted_20 = { class: "card-body" }
const _hoisted_21 = { class: "container-fluid" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "col-md-4" }
const _hoisted_30 = { class: "form-group" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "row" }
const _hoisted_33 = {
  key: 0,
  class: "card"
}
const _hoisted_34 = { class: "card-header" }
const _hoisted_35 = {
  key: 0,
  class: "dropdown float-right"
}
const _hoisted_36 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = { class: "card-body" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = {
  key: 1,
  class: "card"
}
const _hoisted_49 = { class: "card-header" }
const _hoisted_50 = { class: "float-right" }
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = ["onUpdate:modelValue"]
const _hoisted_54 = { class: "row mt-3" }
const _hoisted_55 = { class: "col-md-6" }
const _hoisted_56 = ["onUpdate:modelValue"]
const _hoisted_57 = ["value"]
const _hoisted_58 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_59 = ["onUpdate:modelValue"]
const _hoisted_60 = ["value"]
const _hoisted_61 = {
  key: 0,
  class: "row mt-3"
}
const _hoisted_62 = { class: "col-md-6" }
const _hoisted_63 = ["onUpdate:modelValue"]
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "col-md-6" }
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "row mt-3" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = ["onUpdate:modelValue"]
const _hoisted_71 = { class: "col-md-6" }
const _hoisted_72 = ["onUpdate:modelValue"]
const _hoisted_73 = ["onUpdate:modelValue"]
const _hoisted_74 = { class: "card-footer text-right" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "card" }
const _hoisted_79 = { class: "card-header" }
const _hoisted_80 = { class: "float-right" }
const _hoisted_81 = { class: "dropdown d-inline mr-2" }
const _hoisted_82 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_83 = { class: "dropdown d-inline" }
const _hoisted_84 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = ["onClick"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = ["onClick"]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = { class: "card-body chart-container" }
const _hoisted_95 = ["id"]
const _hoisted_96 = { class: "card" }
const _hoisted_97 = { class: "card-header" }
const _hoisted_98 = { class: "float-right" }
const _hoisted_99 = ["onClick"]
const _hoisted_100 = { class: "card-body" }
const _hoisted_101 = { style: {"height":"40vh","max-height":"40vh","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_102 = ["onUpdate:modelValue"]
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = ["value"]
const _hoisted_105 = { key: 0 }
const _hoisted_106 = ["onUpdate:modelValue"]
const _hoisted_107 = ["value"]
const _hoisted_108 = ["onUpdate:modelValue"]
const _hoisted_109 = { class: "card-footer text-right" }
const _hoisted_110 = ["onClick"]
const _hoisted_111 = ["onClick"]
const _hoisted_112 = { class: "card" }
const _hoisted_113 = { class: "card-header" }
const _hoisted_114 = { class: "float-right" }
const _hoisted_115 = { class: "dropdown d-inline mr-2" }
const _hoisted_116 = {
  class: "dropdown-menu dropdown-menu-right p-3",
  role: "menu",
  style: {"min-width":"400px"}
}
const _hoisted_117 = { class: "align-top" }
const _hoisted_118 = { class: "align-top" }
const _hoisted_119 = { class: "dropdown d-inline" }
const _hoisted_120 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_121 = ["onClick"]
const _hoisted_122 = ["onClick"]
const _hoisted_123 = ["onClick"]
const _hoisted_124 = ["onClick"]
const _hoisted_125 = ["onClick"]
const _hoisted_126 = ["onClick"]
const _hoisted_127 = ["onClick"]
const _hoisted_128 = ["onClick"]
const _hoisted_129 = ["onClick"]
const _hoisted_130 = { class: "card-body chart-container" }
const _hoisted_131 = ["id"]
const _hoisted_132 = { class: "card" }
const _hoisted_133 = { class: "card-header" }
const _hoisted_134 = { class: "float-right" }
const _hoisted_135 = ["onClick"]
const _hoisted_136 = { class: "card-body" }
const _hoisted_137 = { style: {"height":"40vh","max-height":"40vh","overflow-y":"auto","overflow-x":"hidden"} }
const _hoisted_138 = { class: "row" }
const _hoisted_139 = { class: "col-md-6" }
const _hoisted_140 = { class: "form-group" }
const _hoisted_141 = ["onUpdate:modelValue"]
const _hoisted_142 = { class: "col-md-6" }
const _hoisted_143 = { class: "form-group" }
const _hoisted_144 = ["onUpdate:modelValue"]
const _hoisted_145 = ["value"]
const _hoisted_146 = { class: "row" }
const _hoisted_147 = { class: "col-md-6" }
const _hoisted_148 = { class: "form-group" }
const _hoisted_149 = ["onUpdate:modelValue"]
const _hoisted_150 = ["value"]
const _hoisted_151 = { class: "col-md-6" }
const _hoisted_152 = { class: "form-group" }
const _hoisted_153 = ["onUpdate:modelValue"]
const _hoisted_154 = ["value"]
const _hoisted_155 = { class: "table table-bordered" }
const _hoisted_156 = ["onUpdate:modelValue"]
const _hoisted_157 = ["value"]
const _hoisted_158 = { class: "card-footer text-right" }
const _hoisted_159 = ["onClick"]
const _hoisted_160 = ["onClick"]
const _hoisted_161 = { class: "card" }
const _hoisted_162 = { class: "card-header" }
const _hoisted_163 = { class: "float-right" }
const _hoisted_164 = { class: "dropdown d-inline mr-2" }
const _hoisted_165 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_166 = { class: "dropdown d-inline" }
const _hoisted_167 = {
  class: "dropdown-menu dropdown-menu-right",
  role: "menu"
}
const _hoisted_168 = ["onClick"]
const _hoisted_169 = ["onClick"]
const _hoisted_170 = ["onClick"]
const _hoisted_171 = ["onClick"]
const _hoisted_172 = ["onClick"]
const _hoisted_173 = ["onClick"]
const _hoisted_174 = ["onClick"]
const _hoisted_175 = ["onClick"]
const _hoisted_176 = ["onClick"]
const _hoisted_177 = { class: "card-body chart-container" }
const _hoisted_178 = ["id"]
const _hoisted_179 = { class: "card" }
const _hoisted_180 = { class: "card-header" }
const _hoisted_181 = { class: "float-right" }
const _hoisted_182 = ["onClick"]
const _hoisted_183 = { class: "card-body" }
const _hoisted_184 = { class: "form-group" }
const _hoisted_185 = ["onUpdate:modelValue"]
const _hoisted_186 = { class: "mb-2" }
const _hoisted_187 = { class: "dropdown" }
const _hoisted_188 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_189 = {
  class: "dropdown-menu",
  style: {"overflow-y":"auto","max-height":"40vh"}
}
const _hoisted_190 = ["onClick"]
const _hoisted_191 = { class: "mb-2" }
const _hoisted_192 = { class: "dropdown" }
const _hoisted_193 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_194 = {
  class: "dropdown-menu",
  style: {"overflow-y":"auto","max-height":"40vh"}
}
const _hoisted_195 = ["onClick"]
const _hoisted_196 = { class: "mb-2" }
const _hoisted_197 = { class: "dropdown" }
const _hoisted_198 = {
  class: "text-primary",
  "data-toggle": "dropdown"
}
const _hoisted_199 = {
  class: "dropdown-menu",
  style: {"overflow-y":"auto","max-height":"40vh"}
}
const _hoisted_200 = ["onClick"]
const _hoisted_201 = ["onClick"]
const _hoisted_202 = ["onClick"]
const _hoisted_203 = ["onClick"]
const _hoisted_204 = ["onUpdate:modelValue"]
const _hoisted_205 = { class: "card-footer text-right" }
const _hoisted_206 = ["onClick"]
const _hoisted_207 = ["onClick"]
const _hoisted_208 = { class: "bg-light border rounded p-2 mb-1" }
const _hoisted_209 = { class: "d-flex justify-content-between" }
const _hoisted_210 = { class: "btn-toolbar" }
const _hoisted_211 = { class: "btn-group mr-2" }
const _hoisted_212 = {
  class: "btn btn-primary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_213 = { class: "dropdown-menu dropdown-menu-scrollable" }
const _hoisted_214 = {
  key: 0,
  class: "dropdown-header"
}
const _hoisted_215 = ["onClick"]
const _hoisted_216 = { class: "btn-group mr-2" }
const _hoisted_217 = {
  class: "btn btn-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_218 = { class: "dropdown-menu" }
const _hoisted_219 = ["onClick"]
const _hoisted_220 = { class: "btn-group mr-2" }
const _hoisted_221 = ["disabled"]
const _hoisted_222 = { class: "btn-group" }
const _hoisted_223 = { class: "p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumericInputDialog = _resolveComponent("NumericInputDialog")!
  const _component_ListSelectionDialog = _resolveComponent("ListSelectionDialog")!
  const _component_StaticViewBuilder = _resolveComponent("StaticViewBuilder")!
  const _component_ReportEditor = _resolveComponent("ReportEditor")!
  const _component_AlternativeEditorDialog = _resolveComponent("AlternativeEditorDialog")!
  const _component_AlternativesComparisonDialog = _resolveComponent("AlternativesComparisonDialog")!
  const _component_KendoChartFullScreenDialog = _resolveComponent("KendoChartFullScreenDialog")!
  const _component_KendoGridColumnsEditorDialog = _resolveComponent("KendoGridColumnsEditorDialog")!
  const _component_PortfolioOrDecisionNavigation = _resolveComponent("PortfolioOrDecisionNavigation")!
  const _directive_sanitizedHref = _resolveDirective("sanitizedHref")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NumericInputDialog, {
      viewModel: _ctx.numericInputDialog,
      onUpdateValue: _ctx.handleMultipleAlternativesAttributeValueUpdateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateValue"]),
    _createVNode(_component_ListSelectionDialog, {
      viewModel: _ctx.statusListSelectionDialog,
      onUpdateValue: _ctx.handleUpdateMultipleAlternativesStatusCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateValue"]),
    _createVNode(_component_ListSelectionDialog, {
      viewModel: _ctx.attrListSelectionDialog,
      onUpdateValue: _ctx.handleMultipleAlternativesAttributeValueUpdateCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateValue"]),
    _createVNode(_component_StaticViewBuilder, {
      viewModel: _ctx.staticViewBuilder,
      onCreateStaticList: _ctx.handleCreateStaticViewCommand
    }, null, 8 /* PROPS */, ["viewModel", "onCreateStaticList"]),
    _createVNode(_component_ReportEditor, {
      viewModel: _ctx.reportEditor,
      onUpdateReport: _ctx.handleUpdateReportCommand
    }, null, 8 /* PROPS */, ["viewModel", "onUpdateReport"]),
    _createVNode(_component_AlternativeEditorDialog, { viewModel: _ctx.alternativeEditorDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_AlternativesComparisonDialog, { viewModel: _ctx.alternativesComparisonDialog }, null, 8 /* PROPS */, ["viewModel"]),
    _createVNode(_component_KendoChartFullScreenDialog, {
      propOpened: _ctx.fullScreenChart != null,
      propChart: _ctx.fullScreenChart?.Chart,
      propTitle: _ctx.fullScreenChart?.Title,
      onCloseDialog: _cache[0] || (_cache[0] = ($event: any) => (_ctx.fullScreenChart = null))
    }, null, 8 /* PROPS */, ["propOpened", "propChart", "propTitle"]),
    _createVNode(_component_KendoGridColumnsEditorDialog, {
      propOpened: _ctx.kendoGridColumnsEditorDialogOpened,
      propGrid: _ctx.grid,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => (_ctx.kendoGridColumnsEditorDialogOpened = false))
    }, null, 8 /* PROPS */, ["propOpened", "propGrid"]),
    (!_ctx.rm)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, [...(_cache[17] || (_cache[17] = [
          _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
          _createTextVNode(" Loading...", -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    (_ctx.rm?.IsWorkspaceUser)
      ? (_openBlock(), _createBlock(_component_PortfolioOrDecisionNavigation, {
          key: 1,
          workspaceId: _ctx.workspaceId,
          projectId: _ctx.projectId
        }, null, 8 /* PROPS */, ["workspaceId", "projectId"]))
      : _createCommentVNode("v-if", true),
    (_ctx.rm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (_ctx.rm.Readonly)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.rm.Report.Name), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.rm.Report.Description), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.rm.Readonly)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "pointer",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showReportEditor && _ctx.showReportEditor(...args)))
                      }, [
                        _createElementVNode("h1", _hoisted_10, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.rm.Report.Name), 1 /* TEXT */)
                        ]),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.rm.Report.Description), 1 /* TEXT */)
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                (!_ctx.rm.Readonly)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[18] || (_cache[18] = _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-secondary dropdown-toggle",
                          "data-toggle": "dropdown"
                        }, " Create ", -1 /* CACHED */)),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.createMetric && _ctx.createMetric(...args)))
                          }, "Metric"),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createScatterChart && _ctx.createScatterChart(...args)))
                          }, "Scatter plot"),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.createBalancingChart && _ctx.createBalancingChart(...args)))
                          }, "Column chart"),
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createBubbleChart && _ctx.createBubbleChart(...args)))
                          }, "Bubble chart")
                        ])
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_16, [...(_cache[19] || (_cache[19] = [
                        _createTextVNode("Share", -1 /* CACHED */)
                      ]))])), [
                        [_directive_sanitizedHref, `/#/sharing/resource/ReportsDataShareResourceProvider/${_ctx.reportId}`]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-success",
                        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleUpdatePortfolioBalancerReportCommand && _ctx.handleUpdatePortfolioBalancerReportCommand(...args)))
                      }, "Save")
                    ]))
                  : _createCommentVNode("v-if", true)
              ])
            ])
          ]),
          _cache[99] || (_cache[99] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 60px"} }, null, -1 /* CACHED */)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (!_ctx.rm.Readonly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _cache[21] || (_cache[21] = _createElementVNode("label", null, "Filter by list:", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("select", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.SelectedList) = $event))
                              }, [
                                _cache[20] || (_cache[20] = _createElementVNode("option", { value: null }, "All", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Lists, (list) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: list.Id,
                                    value: list
                                  }, _toDisplayString(list.Name), 9 /* TEXT, PROPS */, _hoisted_25))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.SelectedList]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                              _cache[23] || (_cache[23] = _createElementVNode("label", null, "Group by text attribute:", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("select", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.GroupByAttribute) = $event))
                              }, [
                                _cache[22] || (_cache[22] = _createElementVNode("option", { value: null }, "No grouping", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.TextAttributes, (attribute) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: attribute.Id,
                                    value: attribute
                                  }, _toDisplayString(attribute.Name), 9 /* TEXT, PROPS */, _hoisted_28))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.GroupByAttribute]
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              _cache[25] || (_cache[25] = _createElementVNode("label", null, "Edit form:", -1 /* CACHED */)),
                              _withDirectives(_createElementVNode("select", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.Form) = $event))
                              }, [
                                _cache[24] || (_cache[24] = _createElementVNode("option", { value: null }, "None", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rm.Forms, (form) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: form.Id,
                                    value: form
                                  }, _toDisplayString(form.Name), 9 /* TEXT, PROPS */, _hoisted_31))
                                }), 128 /* KEYED_FRAGMENT */))
                              ], 512 /* NEED_PATCH */), [
                                [_vModelSelect, _ctx.Form]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Metrics, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.MetricId,
                    class: _normalizeClass(["mt-3", m.WidthCss])
                  }, [
                    (!m.IsEdited)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            (!_ctx.rm.Readonly)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _cache[30] || (_cache[30] = _createElementVNode("a", {
                                    "data-toggle": "dropdown",
                                    class: "text-dark"
                                  }, [
                                    _createElementVNode("i", { class: "fa fa-lg fa-ellipsis-h" })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_36, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.IsEdited = true)
                                    }, "Edit", 8 /* PROPS */, _hoisted_37),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.clone())
                                    }, "Clone", 8 /* PROPS */, _hoisted_38),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.moveUp())
                                    }, "Move up", 8 /* PROPS */, _hoisted_39),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.moveDown())
                                    }, "Move down", 8 /* PROPS */, _hoisted_40),
                                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _cache[28] || (_cache[28] = _createElementVNode("h6", { class: "dropdown-header" }, "Width", -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.Size = '1/4')
                                    }, "1/4", 8 /* PROPS */, _hoisted_41),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.Size = '1/3')
                                    }, "1/3", 8 /* PROPS */, _hoisted_42),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.Size = '1/2')
                                    }, "1/2", 8 /* PROPS */, _hoisted_43),
                                    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (m.deleteMetric())
                                    }, "Delete", 8 /* PROPS */, _hoisted_44)
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("h5", null, _toDisplayString(m.Title), 1 /* TEXT */)
                          ]),
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("h4", null, [
                              _createElementVNode("span", {
                                style: _normalizeStyle({'color': m.Color})
                              }, _toDisplayString(m.ValueStr), 5 /* TEXT, STYLE */)
                            ]),
                            _createElementVNode("p", null, [
                              (m.LimitMin != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(m.LimitMinStr), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _cache[31] || (_cache[31] = _createTextVNode("  ", -1 /* CACHED */)),
                              _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              (m.LimitMax != null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(m.LimitMaxStr), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _cache[33] || (_cache[33] = _createTextVNode("  ", -1 /* CACHED */))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (m.IsEdited)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createElementVNode("div", _hoisted_50, [
                              _createElementVNode("a", {
                                class: "pointer",
                                onClick: ($event: any) => (m.closeEditor())
                              }, [...(_cache[34] || (_cache[34] = [
                                _createElementVNode("span", {
                                  class: "fa fa-check fa-lg",
                                  style: {"z-index":"100"}
                                }, null, -1 /* CACHED */)
                              ]))], 8 /* PROPS */, _hoisted_51)
                            ]),
                            _cache[35] || (_cache[35] = _createElementVNode("h5", null, "Edit metric", -1 /* CACHED */))
                          ]),
                          _createElementVNode("div", _hoisted_52, [
                            _cache[45] || (_cache[45] = _createElementVNode("h6", null, "Title:", -1 /* CACHED */)),
                            _createElementVNode("p", null, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((m.Title) = $event),
                                class: "form-control"
                              }, null, 8 /* PROPS */, _hoisted_53), [
                                [
                                  _vModelText,
                                  m.Title,
                                  void 0,
                                  { trim: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _cache[37] || (_cache[37] = _createElementVNode("h6", null, "Attribute:", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-control",
                                  "onUpdate:modelValue": ($event: any) => ((m.Attribute) = $event)
                                }, [
                                  _cache[36] || (_cache[36] = _createElementVNode("option", { value: null }, "Number of projects", -1 /* CACHED */)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: attr.Id,
                                      value: attr
                                    }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_57))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 8 /* PROPS */, _hoisted_56), [
                                  [_vModelSelect, m.Attribute]
                                ])
                              ]),
                              (m.Attribute)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                    _cache[38] || (_cache[38] = _createElementVNode("h6", null, "Type:", -1 /* CACHED */)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((m.Type) = $event),
                                      class: "form-control"
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MetricTypes, (t) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: t,
                                          value: t
                                        }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_60))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ], 8 /* PROPS */, _hoisted_59), [
                                      [_vModelSelect, m.Type]
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            (m.Attribute)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _cache[40] || (_cache[40] = _createElementVNode("h6", null, "Currency:", -1 /* CACHED */)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((m.Currency) = $event),
                                      class: "form-control"
                                    }, [
                                      _cache[39] || (_cache[39] = _createElementVNode("option", { value: null }, "None", -1 /* CACHED */)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Currencies, (c) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: c,
                                          value: c
                                        }, _toDisplayString(c), 9 /* TEXT, PROPS */, _hoisted_64))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ], 8 /* PROPS */, _hoisted_63), [
                                      [_vModelSelect, m.Currency]
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_65, [
                                    _cache[42] || (_cache[42] = _createElementVNode("h6", null, "Decimal places:", -1 /* CACHED */)),
                                    _withDirectives(_createElementVNode("select", {
                                      "onUpdate:modelValue": ($event: any) => ((m.Decimals) = $event),
                                      class: "form-control"
                                    }, [
                                      _cache[41] || (_cache[41] = _createElementVNode("option", { value: null }, "All", -1 /* CACHED */)),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DecimalsOptions, (d) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: d,
                                          value: d
                                        }, _toDisplayString(d), 9 /* TEXT, PROPS */, _hoisted_67))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ], 8 /* PROPS */, _hoisted_66), [
                                      [_vModelSelect, m.Decimals]
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _cache[43] || (_cache[43] = _createElementVNode("h6", null, "Min:", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((m.LimitMin) = $event),
                                  class: "form-control"
                                }, null, 8 /* PROPS */, _hoisted_70), [
                                  [
                                    _vModelText,
                                    m.LimitMin,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _cache[44] || (_cache[44] = _createElementVNode("h6", null, "Max:", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((m.LimitMax) = $event),
                                  class: "form-control"
                                }, null, 8 /* PROPS */, _hoisted_72), [
                                  [
                                    _vModelText,
                                    m.LimitMax,
                                    void 0,
                                    { number: true }
                                  ]
                                ])
                              ])
                            ]),
                            _cache[46] || (_cache[46] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                            _cache[47] || (_cache[47] = _createElementVNode("h6", null, "Statuses:", -1 /* CACHED */)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.AlternativesStatusIncludes, (s) => {
                              return (_openBlock(), _createElementBlock("p", {
                                key: s.Id
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => ((s.Included) = $event)
                                }, null, 8 /* PROPS */, _hoisted_73), [
                                  [_vModelCheckbox, s.Included]
                                ]),
                                _createTextVNode(" " + _toDisplayString(s.Name), 1 /* TEXT */)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]),
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("button", {
                              class: "btn btn-success",
                              type: "button",
                              onClick: ($event: any) => (m.closeEditor())
                            }, "Done", 8 /* PROPS */, _hoisted_75),
                            _createElementVNode("button", {
                              class: "btn btn-danger",
                              type: "button",
                              onClick: ($event: any) => (m.deleteMetric())
                            }, "Delete", 8 /* PROPS */, _hoisted_76)
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _createElementVNode("div", _hoisted_77, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ChartsView, (ch) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: ch.ChartId,
                    class: _normalizeClass(["mt-3", ch.ChartCssClass])
                  }, [
                    (ch.Type === 'balancing')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _withDirectives(_createElementVNode("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", _hoisted_80, [
                                _createElementVNode("div", _hoisted_81, [
                                  _cache[48] || (_cache[48] = _createElementVNode("button", {
                                    "data-toggle": "dropdown",
                                    class: "btn btn-secondary btn-sm"
                                  }, "Legend", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_82, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AlternativesGroups, (g) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: g.Name,
                                        class: "dropdown-item-text"
                                      }, [
                                        _createElementVNode("i", {
                                          class: "fa fa-square",
                                          "aria-hidden": "true",
                                          style: _normalizeStyle({color: g.Color})
                                        }, null, 4 /* STYLE */),
                                        _createTextVNode(" " + _toDisplayString(g.Label), 1 /* TEXT */)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_83, [
                                  _cache[53] || (_cache[53] = _createElementVNode("a", {
                                    "data-toggle": "dropdown",
                                    class: "text-dark"
                                  }, [
                                    _createElementVNode("i", { class: "fa fa-lg fa-ellipsis-h" })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_84, [
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.IsEdited = true)
                                        }, "Edit", 8 /* PROPS */, _hoisted_85))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.cloneChart())
                                        }, "Clone", 8 /* PROPS */, _hoisted_86))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.deleteChart())
                                        }, "Delete", 8 /* PROPS */, _hoisted_87))
                                      : _createCommentVNode("v-if", true),
                                    _cache[49] || (_cache[49] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 3,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.moveUp())
                                        }, "Move up", 8 /* PROPS */, _hoisted_88))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 4,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.moveDown())
                                        }, "Move down", 8 /* PROPS */, _hoisted_89))
                                      : _createCommentVNode("v-if", true),
                                    _cache[50] || (_cache[50] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _cache[51] || (_cache[51] = _createElementVNode("h6", { class: "dropdown-header" }, "Chart size", -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Default'))
                                    }, "Default", 8 /* PROPS */, _hoisted_90),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Wide'))
                                    }, "Wide", 8 /* PROPS */, _hoisted_91),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Large'))
                                    }, "Large", 8 /* PROPS */, _hoisted_92),
                                    _cache[52] || (_cache[52] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.showFullScreen(ch))
                                    }, "Full screen", 8 /* PROPS */, _hoisted_93)
                                  ])
                                ])
                              ]),
                              _createElementVNode("h5", null, _toDisplayString(ch.Title), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("div", {
                                id: `Chart-${ch.ChartId}`,
                                style: {"max-width":"100%","height":"100%","overflow":"hidden"}
                              }, null, 8 /* PROPS */, _hoisted_95)
                            ])
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, ch.IsEdited === false]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_96, [
                            _createElementVNode("div", _hoisted_97, [
                              _createElementVNode("div", _hoisted_98, [
                                _createElementVNode("a", {
                                  class: "pointer p-2",
                                  onClick: ($event: any) => (ch.stopEditing())
                                }, [...(_cache[54] || (_cache[54] = [
                                  _createElementVNode("i", { class: "fa fa-check fa-lg" }, null, -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_99)
                              ]),
                              _createElementVNode("h5", null, _toDisplayString(ch.Title), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, [
                                _cache[56] || (_cache[56] = _createElementVNode("h6", null, "Title:", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((ch.Title) = $event),
                                  class: "form-control"
                                }, null, 8 /* PROPS */, _hoisted_102), [
                                  [
                                    _vModelText,
                                    ch.Title,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _cache[58] || (_cache[58] = _createElementVNode("h6", null, "Data:", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("select", {
                                  "onUpdate:modelValue": ($event: any) => ((ch.Attribute) = $event),
                                  class: "form-control"
                                }, [
                                  _cache[55] || (_cache[55] = _createElementVNode("option", { value: null }, "Number of projects", -1 /* CACHED */)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: attr.Id,
                                      value: attr
                                    }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_104))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ], 8 /* PROPS */, _hoisted_103), [
                                  [_vModelSelect, ch.Attribute]
                                ]),
                                _cache[59] || (_cache[59] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                (ch.Attribute)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((ch.MetricType) = $event),
                                        class: "form-control"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MetricTypes, (t) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: t,
                                            value: t
                                          }, _toDisplayString(t), 9 /* TEXT, PROPS */, _hoisted_107))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ], 8 /* PROPS */, _hoisted_106), [
                                        [_vModelSelect, ch.MetricType]
                                      ])
                                    ]))
                                  : _createCommentVNode("v-if", true),
                                _cache[60] || (_cache[60] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                _cache[61] || (_cache[61] = _createElementVNode("h6", null, "Statuses:", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ch.AlternativesStatusIncludes, (s) => {
                                  return (_openBlock(), _createElementBlock("p", {
                                    key: s.Id
                                  }, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": ($event: any) => ((s.Included) = $event)
                                    }, null, 8 /* PROPS */, _hoisted_108), [
                                      [_vModelCheckbox, s.Included]
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(s.Name), 1 /* TEXT */)
                                  ]))
                                }), 128 /* KEYED_FRAGMENT */))
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_109, [
                              _createElementVNode("button", {
                                class: "btn btn-success",
                                type: "button",
                                onClick: ($event: any) => (ch.stopEditing())
                              }, "Done", 8 /* PROPS */, _hoisted_110),
                              _createElementVNode("button", {
                                class: "btn btn-danger",
                                type: "button",
                                onClick: ($event: any) => (ch.deleteChart())
                              }, "Delete", 8 /* PROPS */, _hoisted_111)
                            ])
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, ch.IsEdited]
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (ch.Type === 'scatter')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _withDirectives(_createElementVNode("div", _hoisted_112, [
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("div", _hoisted_115, [
                                  _cache[63] || (_cache[63] = _createElementVNode("button", {
                                    "data-toggle": "dropdown",
                                    class: "btn btn-secondary btn-sm"
                                  }, "Legend", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_116, [
                                    _createElementVNode("table", null, [
                                      _cache[62] || (_cache[62] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", null, "Status"),
                                          _createElementVNode("th", null, "Color")
                                        ])
                                      ], -1 /* CACHED */)),
                                      _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("td", _hoisted_117, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ch.ShapesLegend, (s) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: s.Name
                                              }, [
                                                _createElementVNode("i", {
                                                  class: _normalizeClass(s.ShapeIcon)
                                                }, null, 2 /* CLASS */),
                                                _createTextVNode(" " + _toDisplayString(s.Name), 1 /* TEXT */)
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]),
                                          _createElementVNode("td", _hoisted_118, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AlternativesGroups, (g) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: g.Name
                                              }, [
                                                _createElementVNode("i", {
                                                  class: "fa fa-square",
                                                  "aria-hidden": "true",
                                                  style: _normalizeStyle({'color': g.Color})
                                                }, null, 4 /* STYLE */),
                                                _createTextVNode(" " + _toDisplayString(g.Label), 1 /* TEXT */)
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_119, [
                                  _cache[68] || (_cache[68] = _createElementVNode("a", {
                                    "data-toggle": "dropdown",
                                    class: "text-dark"
                                  }, [
                                    _createElementVNode("i", { class: "fa fa-lg fa-ellipsis-h" })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_120, [
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.IsEdited = true)
                                        }, "Edit", 8 /* PROPS */, _hoisted_121))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.cloneChart())
                                        }, "Clone", 8 /* PROPS */, _hoisted_122))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.deleteChart())
                                        }, "Delete", 8 /* PROPS */, _hoisted_123))
                                      : _createCommentVNode("v-if", true),
                                    _cache[64] || (_cache[64] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 3,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.moveUp())
                                        }, "Move up", 8 /* PROPS */, _hoisted_124))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 4,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.moveDown())
                                        }, "Move down", 8 /* PROPS */, _hoisted_125))
                                      : _createCommentVNode("v-if", true),
                                    _cache[65] || (_cache[65] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _cache[66] || (_cache[66] = _createElementVNode("h6", { class: "dropdown-header" }, "Chart size", -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Default'))
                                    }, "Default", 8 /* PROPS */, _hoisted_126),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Wide'))
                                    }, "Wide", 8 /* PROPS */, _hoisted_127),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Large'))
                                    }, "Large", 8 /* PROPS */, _hoisted_128),
                                    _cache[67] || (_cache[67] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.showFullScreen(ch))
                                    }, "Full screen", 8 /* PROPS */, _hoisted_129)
                                  ])
                                ])
                              ]),
                              _createElementVNode("h5", null, _toDisplayString(ch.Title), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_130, [
                              _createElementVNode("div", {
                                id: `Chart-${ch.ChartId}`,
                                style: {"max-width":"100%","height":"100%","overflow":"hidden"}
                              }, null, 8 /* PROPS */, _hoisted_131)
                            ])
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, ch.IsEdited === false]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_132, [
                            _createElementVNode("div", _hoisted_133, [
                              _createElementVNode("div", _hoisted_134, [
                                _createElementVNode("a", {
                                  class: "pointer p-2",
                                  onClick: ($event: any) => (ch.stopEditing())
                                }, [...(_cache[69] || (_cache[69] = [
                                  _createElementVNode("i", { class: "fa fa-check fa-lg" }, null, -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_135)
                              ]),
                              _cache[70] || (_cache[70] = _createElementVNode("h5", null, "Edit chart", -1 /* CACHED */))
                            ]),
                            _createElementVNode("div", _hoisted_136, [
                              _createElementVNode("div", _hoisted_137, [
                                _createElementVNode("div", _hoisted_138, [
                                  _createElementVNode("div", _hoisted_139, [
                                    _createElementVNode("div", _hoisted_140, [
                                      _cache[71] || (_cache[71] = _createElementVNode("label", null, "Chart title:", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((ch.Title) = $event),
                                        class: "form-control"
                                      }, null, 8 /* PROPS */, _hoisted_141), [
                                        [
                                          _vModelText,
                                          ch.Title,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_142, [
                                    _createElementVNode("div", _hoisted_143, [
                                      _cache[73] || (_cache[73] = _createElementVNode("label", null, "Cumulative axes, order by:", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((ch.RunningTotalOrderAttribute) = $event),
                                        class: "form-control"
                                      }, [
                                        _cache[72] || (_cache[72] = _createElementVNode("option", { value: null }, "disabled", -1 /* CACHED */)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: attr.Id,
                                            value: attr
                                          }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_145))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ], 8 /* PROPS */, _hoisted_144), [
                                        [_vModelSelect, ch.RunningTotalOrderAttribute]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_146, [
                                  _createElementVNode("div", _hoisted_147, [
                                    _createElementVNode("div", _hoisted_148, [
                                      _cache[74] || (_cache[74] = _createElementVNode("label", null, "Y Axis:", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((ch.YAxisAttribute) = $event),
                                        class: "form-control"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: attr.Id,
                                            value: attr
                                          }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_150))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ], 8 /* PROPS */, _hoisted_149), [
                                        [_vModelSelect, ch.YAxisAttribute]
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("div", _hoisted_152, [
                                      _cache[75] || (_cache[75] = _createElementVNode("label", null, "X Axis:", -1 /* CACHED */)),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": ($event: any) => ((ch.XAxisAttribute) = $event),
                                        class: "form-control"
                                      }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: attr.Id,
                                            value: attr
                                          }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_154))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ], 8 /* PROPS */, _hoisted_153), [
                                        [_vModelSelect, ch.XAxisAttribute]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createElementVNode("table", _hoisted_155, [
                                  _cache[76] || (_cache[76] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                      _createElementVNode("th", null, "Status"),
                                      _createElementVNode("th", null, "Shape")
                                    ])
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("tbody", null, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ch.AlternativesStatusIncludes, (s) => {
                                      return (_openBlock(), _createElementBlock("tr", {
                                        key: s.Id
                                      }, [
                                        _createElementVNode("td", null, _toDisplayString(s.Name), 1 /* TEXT */),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": ($event: any) => ((s.Shape) = $event),
                                            class: "form-control"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.StatusShapes, (shape) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: shape,
                                                value: shape
                                              }, _toDisplayString(shape), 9 /* TEXT, PROPS */, _hoisted_157))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ], 8 /* PROPS */, _hoisted_156), [
                                            [_vModelSelect, s.Shape]
                                          ])
                                        ])
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_158, [
                              _createElementVNode("button", {
                                class: "btn btn-success",
                                type: "button",
                                onClick: ($event: any) => (ch.stopEditing())
                              }, "Done", 8 /* PROPS */, _hoisted_159),
                              _createElementVNode("button", {
                                class: "btn btn-danger",
                                type: "button",
                                onClick: ($event: any) => (ch.deleteChart())
                              }, "Delete", 8 /* PROPS */, _hoisted_160)
                            ])
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, ch.IsEdited]
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    (ch.Type === 'bubble')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _withDirectives(_createElementVNode("div", _hoisted_161, [
                            _createElementVNode("div", _hoisted_162, [
                              _createElementVNode("div", _hoisted_163, [
                                _createElementVNode("div", _hoisted_164, [
                                  _cache[77] || (_cache[77] = _createElementVNode("button", {
                                    "data-toggle": "dropdown",
                                    class: "btn btn-secondary btn-sm"
                                  }, "Legend", -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_165, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.AlternativesGroups, (g) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: g.Name,
                                        class: "dropdown-item-text"
                                      }, [
                                        _createElementVNode("i", {
                                          class: "fa fa-square",
                                          "aria-hidden": "true",
                                          style: _normalizeStyle({'color': g.Color})
                                        }, null, 4 /* STYLE */),
                                        _createTextVNode(" " + _toDisplayString(g.Label), 1 /* TEXT */)
                                      ]))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_166, [
                                  _cache[82] || (_cache[82] = _createElementVNode("a", {
                                    "data-toggle": "dropdown",
                                    class: "text-dark"
                                  }, [
                                    _createElementVNode("i", { class: "fa fa-lg fa-ellipsis-h" })
                                  ], -1 /* CACHED */)),
                                  _createElementVNode("div", _hoisted_167, [
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.IsEdited = true)
                                        }, "Edit", 8 /* PROPS */, _hoisted_168))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.cloneChart())
                                        }, "Clone", 8 /* PROPS */, _hoisted_169))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 2,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.deleteChart())
                                        }, "Delete", 8 /* PROPS */, _hoisted_170))
                                      : _createCommentVNode("v-if", true),
                                    _cache[78] || (_cache[78] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 3,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.moveUp())
                                        }, "Move up", 8 /* PROPS */, _hoisted_171))
                                      : _createCommentVNode("v-if", true),
                                    (!_ctx.rm.Readonly)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 4,
                                          class: "dropdown-item",
                                          onClick: ($event: any) => (ch.moveDown())
                                        }, "Move down", 8 /* PROPS */, _hoisted_172))
                                      : _createCommentVNode("v-if", true),
                                    _cache[79] || (_cache[79] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _cache[80] || (_cache[80] = _createElementVNode("h6", { class: "dropdown-header" }, "Chart size", -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Default'))
                                    }, "Default", 8 /* PROPS */, _hoisted_173),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Wide'))
                                    }, "Wide", 8 /* PROPS */, _hoisted_174),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.setSize('Large'))
                                    }, "Large", 8 /* PROPS */, _hoisted_175),
                                    _cache[81] || (_cache[81] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.showFullScreen(ch))
                                    }, "Full screen", 8 /* PROPS */, _hoisted_176)
                                  ])
                                ])
                              ]),
                              _createElementVNode("h5", null, _toDisplayString(ch.Title), 1 /* TEXT */)
                            ]),
                            _createElementVNode("div", _hoisted_177, [
                              _createElementVNode("div", {
                                id: `Chart-${ch.ChartId}`,
                                style: {"max-width":"100%","height":"100%","overflow":"hidden"}
                              }, null, 8 /* PROPS */, _hoisted_178)
                            ])
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, ch.IsEdited === false]
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_179, [
                            _createElementVNode("div", _hoisted_180, [
                              _createElementVNode("div", _hoisted_181, [
                                _createElementVNode("a", {
                                  class: "pointer p-2",
                                  onClick: ($event: any) => (ch.stopEditing())
                                }, [...(_cache[83] || (_cache[83] = [
                                  _createElementVNode("i", { class: "fa fa-check fa-lg" }, null, -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_182)
                              ]),
                              _cache[84] || (_cache[84] = _createElementVNode("h5", null, "Edit chart", -1 /* CACHED */))
                            ]),
                            _createElementVNode("div", _hoisted_183, [
                              _createElementVNode("div", _hoisted_184, [
                                _cache[85] || (_cache[85] = _createElementVNode("label", null, "Chart title:", -1 /* CACHED */)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": ($event: any) => ((ch.Title) = $event),
                                  class: "form-control"
                                }, null, 8 /* PROPS */, _hoisted_185), [
                                  [
                                    _vModelText,
                                    ch.Title,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              _cache[90] || (_cache[90] = _createElementVNode("h6", null, "Axes:", -1 /* CACHED */)),
                              _createElementVNode("div", _hoisted_186, [
                                _createElementVNode("div", _hoisted_187, [
                                  _cache[86] || (_cache[86] = _createTextVNode(" X Axis: ", -1 /* CACHED */)),
                                  _createElementVNode("a", _hoisted_188, _toDisplayString(ch.XaxisLabel), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_189, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attr.Id,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (ch.XAxisAttribute = attr)
                                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_190))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_191, [
                                _createElementVNode("div", _hoisted_192, [
                                  _cache[87] || (_cache[87] = _createTextVNode(" Y Axis: ", -1 /* CACHED */)),
                                  _createElementVNode("a", _hoisted_193, _toDisplayString(ch.YaxisLabel), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_194, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attr.Id,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (ch.YAxisAttribute = attr)
                                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_195))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_196, [
                                _createElementVNode("div", _hoisted_197, [
                                  _cache[89] || (_cache[89] = _createTextVNode(" Bubble Size: ", -1 /* CACHED */)),
                                  _createElementVNode("a", _hoisted_198, _toDisplayString(ch.ZAxisOption.Label), 1 /* TEXT */),
                                  _createElementVNode("div", _hoisted_199, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.ZAxisSetEqualCommand())
                                    }, "Equal", 8 /* PROPS */, _hoisted_200),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.ZAxisSetXYRatioCommand())
                                    }, "Ratio: X/Y", 8 /* PROPS */, _hoisted_201),
                                    _createElementVNode("a", {
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (ch.ZAxisSetYXRatioCommand())
                                    }, "Ratio: Y/X", 8 /* PROPS */, _hoisted_202),
                                    _cache[88] || (_cache[88] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.NumericAttributes, (attr) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: attr.Id,
                                        class: "dropdown-item",
                                        onClick: ($event: any) => (ch.ZAxisSetAttributeCommand(attr))
                                      }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_203))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ])
                                ])
                              ]),
                              _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                              _cache[92] || (_cache[92] = _createElementVNode("h6", null, "Statuses:", -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ch.AlternativesStatusIncludes, (s) => {
                                return (_openBlock(), _createElementBlock("p", {
                                  key: s.Id
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((s.Included) = $event)
                                  }, null, 8 /* PROPS */, _hoisted_204), [
                                    [_vModelCheckbox, s.Included]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(s.Name), 1 /* TEXT */)
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ]),
                            _createElementVNode("div", _hoisted_205, [
                              _createElementVNode("button", {
                                class: "btn btn-success",
                                type: "button",
                                onClick: ($event: any) => (ch.stopEditing())
                              }, "Done", 8 /* PROPS */, _hoisted_206),
                              _createElementVNode("button", {
                                class: "btn btn-danger",
                                type: "button",
                                onClick: ($event: any) => (ch.deleteChart())
                              }, "Delete", 8 /* PROPS */, _hoisted_207)
                            ])
                          ], 512 /* NEED_PATCH */), [
                            [_vShow, ch.IsEdited]
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                }), 128 /* KEYED_FRAGMENT */))
              ]),
              _cache[97] || (_cache[97] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_208, [
                _createElementVNode("div", _hoisted_209, [
                  _createElementVNode("div", _hoisted_210, [
                    (_ctx.SelectedAlternatives.length > 0)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_211, [
                            _createElementVNode("button", _hoisted_212, " Edit selected (" + _toDisplayString(_ctx.SelectedAlternatives.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_213, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.showBulkStatusEditor && _ctx.showBulkStatusEditor(...args)))
                              }, "Status"),
                              _cache[93] || (_cache[93] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.BulkEditableAttributesBySection, (s) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: s.Section
                                }, [
                                  (s.Section)
                                    ? (_openBlock(), _createElementBlock("h6", _hoisted_214, _toDisplayString(s.Section), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(s.Items, (attr) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      key: attr.Id,
                                      class: "dropdown-item",
                                      onClick: ($event: any) => (_ctx.showBulkAttributeValueEditor(attr))
                                    }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_215))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_216, [
                            _createElementVNode("button", _hoisted_217, " Add to list (" + _toDisplayString(_ctx.SelectedAlternatives.length) + ") ", 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_218, [
                              _createElementVNode("a", {
                                class: "dropdown-item",
                                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showStaticViewBuilder && _ctx.showStaticViewBuilder(...args)))
                              }, " Create new list "),
                              _cache[94] || (_cache[94] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.StaticLists, (l) => {
                                return (_openBlock(), _createElementBlock("a", {
                                  class: "dropdown-item",
                                  key: l.Id,
                                  onClick: ($event: any) => (_ctx.handleAddAlternativesToStaticViewCommand(l.Id))
                                }, _toDisplayString(l.Name), 9 /* TEXT, PROPS */, _hoisted_219))
                              }), 128 /* KEYED_FRAGMENT */))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_220, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary",
                              type: "button",
                              disabled: !_ctx.IsStaticList,
                              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleRemoveAlternativesFromStaticViewCommand && _ctx.handleRemoveAlternativesFromStaticViewCommand(...args)))
                            }, " Exclude from list (" + _toDisplayString(_ctx.SelectedAlternatives.length) + ") ", 9 /* TEXT, PROPS */, _hoisted_221)
                          ]),
                          _createElementVNode("div", _hoisted_222, [
                            _createElementVNode("button", {
                              class: "btn btn-secondary",
                              type: "button",
                              onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.showAlternativesComparison && _ctx.showAlternativesComparison(...args)))
                            }, " Compare (" + _toDisplayString(_ctx.SelectedAlternatives.length) + ") ", 1 /* TEXT */)
                          ])
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_223, [
                    (!_ctx.rm.Readonly)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          class: "pointer pr-2",
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.showGridColumnsEditor && _ctx.showGridColumnsEditor(...args))),
                          title: "Edit columns"
                        }, [...(_cache[95] || (_cache[95] = [
                          _createElementVNode("i", { class: "fa fa-columns fa-lg" }, null, -1 /* CACHED */)
                        ]))]))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("a", {
                      class: "pointer pr-2",
                      onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.exportGrid && _ctx.exportGrid(...args))),
                      title: "Download to spreadsheet"
                    }, [...(_cache[96] || (_cache[96] = [
                      _createElementVNode("i", { class: "fa fa-download fa-lg" }, null, -1 /* CACHED */)
                    ]))])
                  ])
                ])
              ]),
              _cache[98] || (_cache[98] = _createElementVNode("div", { id: "pbGrid" }, null, -1 /* CACHED */))
            ])
          ]),
          _cache[100] || (_cache[100] = _createElementVNode("br", null, null, -1 /* CACHED */)),
          _cache[101] || (_cache[101] = _createElementVNode("br", null, null, -1 /* CACHED */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}